module.exports = __webpack_public_path__ + "static/media/logo-wirebit-transfer.aba5f46a.png";